// @flow
import { createContext } from 'react';

// $FlowFixMe
const RouteDataLoaderContext = createContext();

export default RouteDataLoaderContext;
